import { Box, TextField, Typography } from "@mui/material";
import React from "react";

interface StepProps {
  formik: any;
}

const BecomeSellerFormStep3: React.FC<StepProps> = ({ formik }) => {
  return (
    <Box className="space-y-6">
      <Typography variant="h6" className="text-center font-bold pb-2">
        Banking & Payout Details
      </Typography>

      <div className="space-y-5">
        <TextField
          fullWidth
          name="bankDetails.bankName"
          label="Bank Name"
          value={formik.values.bankDetails?.bankName}
          onChange={formik.handleChange}
          onBlur={formik.handleBlur}
          error={
            formik.touched.bankDetails?.bankName &&
            Boolean(formik.errors.bankDetails?.bankName)
          }
          helperText={
            formik.touched.bankDetails?.bankName &&
            formik.errors.bankDetails?.bankName
          }
        />

        <TextField
          fullWidth
          name="bankDetails.accountHolderName"
          label="Account Holder Name"
          value={formik.values.bankDetails?.accountHolderName}
          onChange={formik.handleChange}
          onBlur={formik.handleBlur}
          error={
            formik.touched.bankDetails?.accountHolderName &&
            Boolean(formik.errors.bankDetails?.accountHolderName)
          }
          helperText={
            formik.touched.bankDetails?.accountHolderName &&
            formik.errors.bankDetails?.accountHolderName
          }
        />

        <TextField
          fullWidth
          name="bankDetails.accountNumber"
          label="Account Number / Paybill Account"
          value={formik.values.bankDetails?.accountNumber}
          onChange={formik.handleChange}
          onBlur={formik.handleBlur}
          error={
            formik.touched.bankDetails?.accountNumber &&
            Boolean(formik.errors.bankDetails?.accountNumber)
          }
          helperText={
            formik.touched.bankDetails?.accountNumber &&
            formik.errors.bankDetails?.accountNumber
          }
        />

        <TextField
          fullWidth
          name="bankDetails.branchCode"
          label="Branch Code / Swift Code"
          value={formik.values.bankDetails?.branchCode}
          onChange={formik.handleChange}
          onBlur={formik.handleBlur}
          error={
            formik.touched.bankDetails?.branchCode &&
            Boolean(formik.errors.bankDetails?.branchCode)
          }
          helperText={
            formik.touched.bankDetails?.branchCode &&
            formik.errors.bankDetails?.branchCode
          }
        />
      </div>
    </Box>
  );
};

export default BecomeSellerFormStep3;